import React, { useState } from "react";
import "./CustomerCustomTab.css";

const CustomerCustomTab = ({ tabs, defaultTab, onChange }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabClick = (id) => {
    setActiveTab(id);
    onChange?.(id);
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        {tabs?.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab?.id)}
              className={`tab-button-customer ${isActive ? "active" : ""}`}
            >
              {tab?.label}

              {isActive && <span className="active-line"></span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CustomerCustomTab;
